import _ from 'underscore'
import $ from 'jquery'
import Backbone from '@polleverywhere/backbone'
import Base from './base'

/*
 * A registration is the link between a presenter and a participant who has
 * chosen to share additional information (such as name and possibly an ID number)
 * with the presenter.
 * It may or may not be paid.
 * It is closely related to our "memberships" database table.
 * @namespace Model
 */
class Registration extends Base {
  urlRoot () {
    return '/api/registrations'
  }
}

Registration.create = function (presenter, params = {}) {
  const promise = $.Deferred()

  Backbone.ajax({
    dataType: 'json',
    contentType: 'application/json',
    url: '/api/registrations',
    method: 'POST',
    data: JSON.stringify(_.extend({
      email: presenter
    }, params))
  })
    .done(promise.resolve)
    .fail(xhr => {
      let message
      if (xhr.status === 401) {
        message = 'You must be logged in to register with a presenter'
      } else if (xhr.status === 404) {
        message = 'Unable to find presenter to register with'
      } else if (xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.message) {
        message = xhr.responseJSON.error.message
      } else {
        message = 'Unexpected error while registering, please contact support@polleverywhere.com'
      }
      promise.reject(message, xhr)
    })

  return promise.promise()
}

export default Registration
